import { renderToast, toast } from "components/UI/ToastNotification";
import { ORGANIZATION_CONSTANTS } from "constants/organization";
import { navigate } from "hooks/useHookRouterCompat";
import { useAPI } from "lib/API";
import { createBusinessUnit, updateBusinessUnit } from "requests/organization";
import { useBusinessUnit } from "context/businessUnit";

interface UseBusinessUnitRequestProps {
    setShowCreateModal: (show: boolean) => void;
    setReloadListing: (reload: boolean) => void;
    reset: () => void;
}

export const useBusinessUnitRequest = ({
    setShowCreateModal,
    setReloadListing,
    reset
}: UseBusinessUnitRequestProps) => {
    const { refetchBusinessUnits } = useBusinessUnit();

    const createBusinessUnitReq = useAPI({
        deferFn: createBusinessUnit,
        onResolve: async () => {
            renderToast(toast.TYPE.SUCCESS, ORGANIZATION_CONSTANTS.BUSINESS_UNIT_CREATED);
            setShowCreateModal(false);
            setReloadListing(true);
            reset();
            // Refetch business units to update the global list
            await refetchBusinessUnits();
        },
        onReject: err => {
            renderToast(toast.TYPE.ERROR, err.message);
        }
    });

    const updateBusinessUnitReq = useAPI({
        deferFn: updateBusinessUnit,
        onResolve: async (result) => {
            renderToast(toast.TYPE.SUCCESS, ORGANIZATION_CONSTANTS.BUSINESS_UNIT_UPDATED);
            navigate('/organizations');
            setReloadListing(true);
            reset();
            // Refetch business units to update the global list
            await refetchBusinessUnits();
        },
        onReject: err => {
            renderToast(toast.TYPE.ERROR, err.message);
        }
    });
    return {
        createBusinessUnitReq,
        updateBusinessUnitReq
    }
}